/**
 * The words the Generate pages put to a run's parts.
 *
 * The stages are the drafting engine's own list (`RunStage`), so a stage the
 * engine adds fails the type check here until it has its words.
 */

import type { RunStage } from "@patent-studio/api-types";

const STAGE_LABELS: Readonly<Record<RunStage, string>> = {
  section_writers: "Drafting the Detailed Description",
  abstract: "Writing the abstract and checking the draft",
  render: "Assembling the draft",
  review_marks: "Marking passages for your review",
  store: "Saving your draft",
};

export const DRAFTING = "Drafting your patent";

export function stageLabel(stage: RunStage): string {
  return STAGE_LABELS[stage];
}
